/* ════════════════════════════════════════════════════════════
   PDP TOP — TLPC  interactions
   Gallery, variant→media sync (native variant-selects),
   pack selector (quantity), PIN check, accordions,
   "You may also like" (complementary products) carousel + add.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.ptlInit === 'true') return;
    root.dataset.ptlInit = 'true';

    var sectionId = root.dataset.sectionId;

    /* ── Gallery ─────────────────────────────────────────── */
    var mediaItems = root.querySelectorAll('[data-ptl-media]');
    var thumbs = root.querySelectorAll('[data-ptl-thumb]');

    function activateMedia(id) {
      var found = false;
      mediaItems.forEach(function (m) {
        var active = m.dataset.mediaId === String(id);
        m.classList.toggle('is-active', active);
        if (active) found = true;
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === String(id));
      });
      /* keep the active thumbnail visible in the (scrollable) thumbs row */
      if (thumbsRow && thumbsRow.scrollWidth > thumbsRow.clientWidth) {
        var activeThumb = thumbsRow.querySelector('[data-ptl-thumb].is-active');
        if (activeThumb) {
          var target = activeThumb.offsetLeft - (thumbsRow.clientWidth - activeThumb.offsetWidth) / 2;
          thumbsRow.scrollTo({ left: target, behavior: 'smooth' });
        }
      }
      return found;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        activateMedia(t.dataset.mediaId);
      });
    });

    /* thumbnails: wheel + drag horizontal scrolling (scrollbar is hidden) */
    var thumbsRow = root.querySelector('.ptl__thumbs');
    if (thumbsRow) {
      thumbsRow.addEventListener('wheel', function (e) {
        if (thumbsRow.scrollWidth <= thumbsRow.clientWidth) return;
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          thumbsRow.scrollLeft += e.deltaY;
        }
      }, { passive: false });

      var dragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;
      thumbsRow.addEventListener('pointerdown', function (e) {
        if (thumbsRow.scrollWidth <= thumbsRow.clientWidth) return;
        dragging = true;
        dragMoved = false;
        dragStartX = e.clientX;
        dragStartScroll = thumbsRow.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 5) dragMoved = true;
        thumbsRow.scrollLeft = dragStartScroll - dx;
      });
      window.addEventListener('pointerup', function () { dragging = false; });
      /* suppress the click that ends a drag so it doesn't switch media */
      thumbsRow.addEventListener('click', function (e) {
        if (dragMoved) { e.stopPropagation(); e.preventDefault(); dragMoved = false; }
      }, true);
    }

    /* ── Main image: swipe / drag to slide between media ──
         Dragging the big image left/right slides the previous or
         next catalogue image in (touch + mouse, loops at the ends). */
    var mediaWrap = root.querySelector('.ptl__media');
    if (mediaWrap && mediaItems.length > 1) {
      var mediaList = Array.prototype.slice.call(mediaItems);

      /* stop native image ghost-drag on desktop */
      mediaWrap.addEventListener('dragstart', function (e) { e.preventDefault(); });

      var sw = {
        active: false,    /* pointer is down */
        locked: false,    /* horizontal swipe confirmed */
        animating: false, /* settle animation running */
        startX: 0,
        startY: 0,
        dx: 0,
        dir: 0,           /* 1 = dragging right (→ previous), -1 = dragging left (→ next) */
        from: null,
        to: null
      };

      function swActiveIdx() {
        for (var i = 0; i < mediaList.length; i++) {
          if (mediaList[i].classList.contains('is-active')) return i;
        }
        return 0;
      }

      function swPrep(el) {
        if (!el) return;
        el.style.transition = 'none';
        el.style.opacity = '1';
        el.style.zIndex = '2';
        el.style.pointerEvents = 'none';
      }

      function swMove(el, x, animate) {
        if (!el) return;
        el.style.transition = animate ? 'transform .3s ease' : 'none';
        el.style.transform = 'translateX(' + x + 'px)';
      }

      function swClear(el) {
        if (!el) return;
        el.style.transition = 'none'; /* avoid a crossfade flash on cleanup */
        el.style.transform = '';
        el.style.opacity = '';
        el.style.zIndex = '';
        el.style.pointerEvents = '';
        requestAnimationFrame(function () { el.style.transition = ''; });
      }

      /* pick (or re-pick, if drag direction flips) the incoming slide */
      function swPickNeighbor() {
        var dir = sw.dx > 0 ? 1 : -1;
        if (dir === sw.dir && sw.to) return;
        if (sw.to) swClear(sw.to);
        sw.dir = dir;
        var len = mediaList.length;
        sw.to = mediaList[(swActiveIdx() - dir + len) % len];
        swPrep(sw.to);
      }

      mediaWrap.addEventListener('pointerdown', function (e) {
        if (sw.animating) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        /* don't hijack video / embed controls */
        if (e.target.closest('video, iframe')) return;
        sw.active = true;
        sw.locked = false;
        sw.startX = e.clientX;
        sw.startY = e.clientY;
        sw.dx = 0;
        sw.dir = 0;
        sw.from = mediaList[swActiveIdx()];
        sw.to = null;
      });

      window.addEventListener('pointermove', function (e) {
        if (!sw.active) return;
        var dx = e.clientX - sw.startX;
        var dy = e.clientY - sw.startY;
        if (!sw.locked) {
          /* vertical intent → let the page scroll */
          if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
            sw.active = false;
            return;
          }
          /* need a clear horizontal move before taking over */
          if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
          sw.locked = true;
          swPrep(sw.from);
        }
        sw.dx = dx;
        swPickNeighbor();
        var w = mediaWrap.clientWidth;
        swMove(sw.from, dx, false);
        swMove(sw.to, dx - sw.dir * w, false);
      });

      function swEnd() {
        if (!sw.active) return;
        sw.active = false;
        if (!sw.locked) return;
        var w = mediaWrap.clientWidth;
        var commit = sw.to && Math.abs(sw.dx) > Math.max(50, w * 0.18);
        var from = sw.from;
        var to = sw.to;
        var dir = sw.dir;
        sw.locked = false;
        sw.animating = true;
        if (commit) {
          /* finish the slide, then hand over to the normal active state */
          swMove(from, dir * w, true);
          swMove(to, 0, true);
          setTimeout(function () {
            activateMedia(to.dataset.mediaId);
            swClear(from);
            swClear(to);
            sw.animating = false;
          }, 320);
        } else {
          /* not far enough — spring back */
          swMove(from, 0, true);
          if (to) swMove(to, -dir * w, true);
          setTimeout(function () {
            swClear(from);
            swClear(to);
            sw.animating = false;
          }, 320);
        }
      }

      window.addEventListener('pointerup', swEnd);
      window.addEventListener('pointercancel', swEnd);
    }

    /* ── Mark the colour option fieldset (CSS renders it as dots;
         other options stay as pills, e.g. Size) ─────────────── */
    var pickerWrap = root.querySelector('.ptl__native-picker[data-ptl-color-index]');
    if (pickerWrap) {
      var colorIdx = parseInt(pickerWrap.dataset.ptlColorIndex || '0', 10);
      if (colorIdx > 0) {
        var pickerFieldsets = pickerWrap.querySelectorAll('fieldset');
        if (pickerFieldsets[colorIdx - 1]) {
          pickerFieldsets[colorIdx - 1].classList.add('ptl__opt-color');
        }
      }
    }

    /* ── Native variant data (from variant-selects JSON) ─── */
    var form = document.getElementById('product-form-' + sectionId);
    var packGrid = root.querySelector('[data-ptl-pack-grid]');
    var packsIndex = packGrid ? parseInt(packGrid.dataset.packsIndex, 10) : -1;
    var variantDataCache = null;

    function getVariantData() {
      if (variantDataCache) return variantDataCache;
      var jsonEl = root.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
      if (!jsonEl) return null;
      try { variantDataCache = JSON.parse(jsonEl.textContent); } catch (e) { variantDataCache = null; }
      return variantDataCache;
    }

    function fmtMoney(cents) {
      var v = cents / 100;
      return '₹' + (v % 1 === 0 ? v.toLocaleString('en-IN') : v.toFixed(2));
    }

    /* Sync gallery + pack cards to the current variant */
    function syncToVariant(variantId) {
      var data = getVariantData();
      if (!data) return;
      var cur = data.find(function (v) { return String(v.id) === String(variantId); });
      if (!cur) return;

      if (cur.featured_media && cur.featured_media.id) {
        activateMedia(cur.featured_media.id);
      }

      if (!packGrid || packsIndex < 0) return;
      var curPack = cur.options[packsIndex];

      var refUnit = null;
      packGrid.querySelectorAll('[data-ptl-pack]').forEach(function (card) {
        var val = card.dataset.value;
        var selected = val === curPack;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');

        /* variant for this pack value + the other currently selected options */
        var match = data.find(function (v) {
          return v.options.every(function (opt, i) {
            return i === packsIndex ? opt === val : opt === cur.options[i];
          });
        });
        if (!match) return;

        var priceEl = card.querySelector('[data-ptl-pack-price]');
        var compEl = card.querySelector('[data-ptl-pack-compare]');
        var saveEl = card.querySelector('[data-ptl-pack-save]');
        var hasCompare = match.compare_at_price && match.compare_at_price > match.price;

        if (priceEl) priceEl.textContent = fmtMoney(match.price);
        if (compEl) {
          compEl.hidden = !hasCompare;
          compEl.textContent = hasCompare ? fmtMoney(match.compare_at_price) : '';
        }
        if (saveEl) saveEl.textContent = hasCompare ? 'You Save ' + fmtMoney(match.compare_at_price - match.price) : '';
        card.classList.toggle('is-unavailable', !match.available);

        /* Per-unit pricing (list layout) */
        var qty = parseInt(card.dataset.qty, 10) || 1;
        var unitNow = match.price;
        if (refUnit === null) refUnit = unitNow;
        var unitWas = refUnit;
        var unitOff = Math.max(unitWas - unitNow, 0);
        var totalSave = unitOff * qty;

        var subEl = card.querySelector('[data-ptl-pack-sub]');
        var eachWasEl = card.querySelector('[data-ptl-pack-each-was]');
        var eachNowEl = card.querySelector('[data-ptl-pack-each-now]');
        var eachSaveEl = card.querySelector('[data-ptl-pack-each-save]');
        if (subEl) subEl.textContent = unitOff > 0 ? 'Get ' + fmtMoney(unitOff) + ' off each' : 'Standard price';
        if (eachNowEl) eachNowEl.textContent = fmtMoney(unitNow);
        if (eachWasEl) {
          eachWasEl.hidden = unitOff <= 0;
          eachWasEl.textContent = fmtMoney(unitWas);
        }
        if (eachSaveEl) {
          eachSaveEl.hidden = totalSave <= 0;
          eachSaveEl.innerHTML = 'You save <b>' + fmtMoney(totalSave) + '</b>';
        }
      });
    }

    /* variant-selects (global.js) updates input[name="id"] and fires change */
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.addEventListener('change', function () {
          syncToVariant(idInput.value);
        });
      }
    }

    /* ── Pack card click → select the native Packs radio/option ── */
    function selectPack(card) {
      var val = card.dataset.value;
      var picker = root.querySelector('.ptl__native-picker variant-selects, .ptl__native-picker variant-radios');
      if (!picker || val == null) return;

      /* pill / swatch radios */
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === val) {
          if (!radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }

      /* dropdown fallback */
      var selects = picker.querySelectorAll('select');
      for (var j = 0; j < selects.length; j++) {
        var opt = Array.prototype.find.call(selects[j].options, function (o) { return o.value === val; });
        if (opt) {
          selects[j].value = val;
          selects[j].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    root.querySelectorAll('[data-ptl-pack]').forEach(function (pack) {
      pack.addEventListener('click', function () { selectPack(pack); });
      pack.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPack(pack); }
      });
    });

    /* ── Pre-select the nth pack (position-based, works with any
         option value names; skipped when the URL has ?variant=) ── */
    if (packGrid) {
      var defaultPos = parseInt(packGrid.dataset.defaultPackPos || '0', 10);
      var hasVariantParam = /[?&]variant=/.test(window.location.search);
      if (defaultPos > 0 && !hasVariantParam) {
        var cards = packGrid.querySelectorAll('[data-ptl-pack]');
        var defaultCard = cards[defaultPos - 1];
        if (defaultCard && !defaultCard.classList.contains('is-selected') && !defaultCard.classList.contains('is-unavailable')) {
          selectPack(defaultCard);
        }
      }
    }

    /* ── Accordion step images: decorate the first <ul> of the
         rich-text content with round images (per-product) ──── */
    root.querySelectorAll('.ptl__acc-content[data-ptl-step-images]').forEach(function (content) {
      var urls = (content.dataset.ptlStepImages || '').split('||');
      var list = content.querySelector('ul');
      if (!list) return;
      list.classList.add('ptl__acc-steps');
      var items = list.querySelectorAll(':scope > li');
      urls.forEach(function (url, i) {
        url = url.trim();
        if (!url || !items[i]) return;
        var span = document.createElement('span');
        span.className = 'ptl__acc-step-img';
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 80;
        img.height = 80;
        span.appendChild(img);
        items[i].classList.add('ptl__acc-step--img');
        items[i].insertBefore(span, items[i].firstChild);
      });
    });

    /* ── Accordions ──────────────────────────────────────── */
    root.querySelectorAll('[data-ptl-acc]').forEach(function (acc) {
      var trigger = acc.querySelector('[data-ptl-acc-trigger]');
      var body = acc.querySelector('[data-ptl-acc-body]');
      if (!trigger || !body) return;
      if (acc.classList.contains('is-open')) {
        body.style.maxHeight = body.scrollHeight + 'px';
      }
      trigger.addEventListener('click', function () {
        var isOpen = acc.classList.contains('is-open');
        root.querySelectorAll('[data-ptl-acc].is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var b = o.querySelector('[data-ptl-acc-body]');
          if (b) b.style.maxHeight = '0px';
          var t = o.querySelector('[data-ptl-acc-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          acc.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ── You may also like (loads async via product-recommendations)
         → use event delegation so late-loaded content works ── */
    root.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-ptl-ymal-prev]');
      var next = e.target.closest('[data-ptl-ymal-next]');
      var add = e.target.closest('[data-ptl-ymal-add]');

      if (prev || next) {
        var track = root.querySelector('[data-ptl-ymal-track]');
        if (!track) return;
        var card = track.querySelector('.ptl__ymal-card');
        var step = card ? card.offsetWidth + 10 : 300;
        track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
        return;
      }

      if (add) quickAdd(add);
    });

    function quickAdd(btn) {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';

      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');
      var sectionsToFetch = [];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        sectionsToFetch = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      } else if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
        sectionsToFetch = cartNotification.getSectionsToRender().map(function (s) { return s.id; });
      }

      var body = {
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      };

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status && response.status !== 200) throw new Error(response.description || 'Error');
          var target = cartDrawer || cartNotification;
          if (target && typeof target.renderContents === 'function') {
            target.renderContents(response);
          }
          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ptl-section]').forEach(initSection);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('[data-ptl-section]');
    if (el) { el.dataset.ptlInit = ''; initSection(el); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
}());
